import i18n from "@mirage/translations";

import type { ContentType } from "@mirage/shared/content-type/content-types";

export const DEFAULT_SNIPPET_LINES_SHOWN = 2;
export const DEFAULT_LIST_LIMIT = 2;
export const DEFAULT_GRID_LIMIT = 4;

export type CategoryConfig = {
  id: string;
  label: string;
  layout: "grid" | "list";
  contentType: ContentType;
  defaultOpen?: boolean;
  limit: number;
  snippetLinesShown?: number;
};

const messagesCategoryConfig: CategoryConfig = {
  id: "messages",
  label: i18n.t("related_messages"),
  layout: "list",
  contentType: {
    key: "chat",
    label: () => i18n.t("chat_content_type"),
  },
  defaultOpen: true,
  limit: DEFAULT_LIST_LIMIT,
  snippetLinesShown: DEFAULT_SNIPPET_LINES_SHOWN,
};
export const imagesCategoryConfig: CategoryConfig = {
  id: "images",
  label: i18n.t("related_images"),
  layout: "grid",
  contentType: {
    key: "image",
    label: () => i18n.t("image_content_type"),
  },
  defaultOpen: true,
  limit: DEFAULT_GRID_LIMIT,
};

const emailCategoryConfig: CategoryConfig = {
  id: "emails",
  label: i18n.t("related_emails"),
  layout: "list",
  contentType: {
    key: "email",
    label: () => i18n.t("email_content_type"),
  },
  defaultOpen: true,
  limit: DEFAULT_LIST_LIMIT,
  snippetLinesShown: DEFAULT_SNIPPET_LINES_SHOWN,
};

export const defaultCategoryConfig: CategoryConfig[] = [
  imagesCategoryConfig,
  messagesCategoryConfig,
  emailCategoryConfig,
];
